import React, {useState, useEffect, useCallback, useRef} from 'react';
import './home.scss';
import DataGrid, {
    Paging, SearchPanel, HeaderFilter, FilterRow, DataGridTypes, Export, LoadPanel, Column
} from 'devextreme-react/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import {Workbook} from "exceljs";
import {exportDataGrid} from "devextreme/excel_exporter";
import {saveAs} from "file-saver-es";
import Chart, {ArgumentAxis, Legend, Series, ValueAxis, Label, Title} from 'devextreme-react/chart';
import copy from 'copy-to-clipboard';
import MonitoringMM from './MonitoringMM';

// Константы вынесены наружу


const FEDERAL_DISTRICTS = {
  'Центральный ФО': [
    'Белгородская область',
    'Брянская область',
    'Владимирская область',
    'Воронежская область',
    'Ивановская область',
    'Калужская область',
    'Костромская область',
    'Курская область',
    'Липецкая область',
    'Москва',
    'Московская область',
    'Орловская область',
    'Рязанская область',
    'Смоленская область',
    'Тамбовская область',
    'Тверская область',
    'Тульская область',
    'Ярославская область'
  ],
  'Северо-Западный ФО': [
    'Архангельская область',
    'Вологодская область',
    'Калининградская область',
    'Ленинградская область',
    'Мурманская область',
    'Ненецкий автономный округ',
    'Новгородская область',
    'Псковская область',
    'Республика Карелия',
    'Республика Коми',
    'Санкт-Петербург'
  ],
  'Южный ФО': [
    'Астраханская область',
    'Волгоградская область',
    'Краснодарский край',
    'Республика Адыгея',
    'Республика Калмыкия',
    'Ростовская область',
    'Республика Крым',
    'Севастополь',
    'Донецкая Народная Республика',
    'Запорожская область',
    'Луганская Народная Республика',
    'Херсонская область'
  ],
  'Северо-Кавказский ФО': [
    'Кабардино-Балкарская Республика',
    'Карачаево-Черкесская Республика',
    'Республика Дагестан',
    'Республика Ингушетия',
    'Республика Северная Осетия - Алания',
    'Ставропольский край',
    'Чеченская Республика'
  ],
  'Приволжский ФО': [
    'Кировская область',
    'Нижегородская область',
    'Оренбургская область',
    'Пензенская область',
    'Пермский край',
    'Республика Башкортостан',
    'Республика Марий Эл',
    'Республика Мордовия',
    'Республика Татарстан',
    'Самарская область',
    'Саратовская область',
    'Удмуртская Республика',
    'Ульяновская область',
    'Чувашская Республика'
  ],
  'Уральский ФО': [
    'Курганская область',
    'Свердловская область',
    'Тюменская область',
    'Челябинская область',
    'Ханты-Мансийский автономный округ - Югра',
    'Ямало-Ненецкий автономный округ'
  ],
  'Сибирский ФО': [
    'Алтайский край',
    'Иркутская область',
    'Кемеровская область',
    'Красноярский край',
    'Новосибирская область',
    'Омская область',
    'Республика Алтай',
    'Республика Тыва',
    'Республика Хакасия',
    'Томская область'
  ],
  'Дальневосточный ФО': [
    'Амурская область',
    'Еврейская автономная область',
    'Забайкальский край',
    'Камчатский край',
    'Магаданская область',
    'Приморский край',
    'Республика Бурятия',
    'Республика Саха',
    'Сахалинская область',
    'Хабаровский край',
    'Чукотский автономный округ'
  ]
};

// Данные из Excel файла о количестве учащихся начальной школы по регионам
const STUDENTS_DATA = {
    'Москва': 476385,
    'Московская область': 473307,
    'Белгородская область': 62643,
    'Брянская область': 49705,
    'Владимирская область': 60176,
    'Воронежская область': 103877,
    'Ивановская область': 41816,
    'Калужская область': 51682,
    'Костромская область': 29858,
    'Курская область': 45900,
    'Липецкая область': 50618,
    'Орловская область': 30864,
    'Рязанская область': 49648,
    'Смоленская область': 37730,
    'Тамбовская область': 39783,
    'Тверская область': 56089,
    'Тульская область': 60779,
    'Ярославская область': 59023,
    'Санкт-Петербург': 254075,
    'Ленинградская область': 91850,
    'Архангельская область': 48890,
    'Вологодская область': 59955,
    'Калининградская область': 52894,
    'Мурманская область': 33150,
    'Новгородская область': 27439,
    'Псковская область': 27453,
    'Республика Карелия': 28231,
    'Республика Коми': 39791,
    'Ненецкий автономный округ': 2772,
    'Республика Адыгея': 25517,
    'Республика Калмыкия': 12671,
    'Республика Крым': 93103,
    'Краснодарский край': 322258,
    'Астраханская область': 50675,
    'Волгоградская область': 104826,
    'Ростовская область': 193902,
    'Севастополь': 22679,
    'Республика Дагестан': 210204,
    'Республика Ингушетия': 34427,
    'Кабардино-Балкарская Республика': 49457,
    'Карачаево-Черкесская Республика': 24658,
    'Республика Северная Осетия - Алания': 38169,
    'Чеченская Республика': 126117,
    'Ставропольский край': 136078,
    'Республика Башкортостан': 214077,
    'Республика Марий Эл': 36258,
    'Республика Мордовия': 28842,
    'Республика Татарстан': 216223,
    'Удмуртская Республика': 80653,
    'Чувашская Республика': 62181,
    'Кировская область': 59389,
    'Нижегородская область': 147804,
    'Оренбургская область': 100690,
    'Пензенская область': 53614,
    'Пермский край': 139641,
    'Самарская область': 152882,
    'Саратовская область': 101228,
    'Ульяновская область': 54499,
    'Курганская область': 40196,
    'Свердловская область': 233119,
    'Тюменская область': 102678,
    'Челябинская область': 178483,
    'Ханты-Мансийский автономный округ - Югра': 97099,
    'Ямало-Ненецкий автономный округ': 33601,
    'Республика Алтай': 14557,
    'Республика Бурятия': 59351,
    'Республика Тыва': 27911,
    'Республика Хакасия': 30006,
    'Алтайский край': 112176,
    'Забайкальский край': 57412,
    'Красноярский край': 150688,
    'Иркутская область': 133593,
    'Кемеровская область': 121284,
    'Новосибирская область': 152991,
    'Омская область': 96448,
    'Томская область': 51020,
    'Республика Саха': 59109,
    'Камчатский край': 15603,
    'Приморский край': 88122,
    'Хабаровский край': 64680,
    'Амурская область': 38649,
    'Магаданская область': 6120,
    'Сахалинская область': 26256,
    'Еврейская автономная область': 7787,
    'Чукотский автономный округ': 2861
};

const getFederalDistrict = (region) => {
    for (const [district, regions] of Object.entries(FEDERAL_DISTRICTS)) {
        if (regions.includes(region)) {
            return district;
        }
    }
    return 'Другие';
};

// Компонент разворачивающейся секции "О мониторинге"
const MonitoringSection = () => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleSection = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className="monitoring-section" style={{ marginBottom: '20px' }}>
            <style>
                {`
                .monitoring-section {
                    font-family: Arial, sans-serif;
                }
                .monitoring-header {
                    background: #f8f9fa;
                    border: 1px solid #e0e0e0;
                    border-radius: 8px;
                    padding: 15px 20px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                .monitoring-header:hover {
                    background: #e9ecef;
                    border-color: #1976d2;
                }
                .monitoring-header h2 {
                    margin: 0;
                    color: #1976d2;
                    font-size: 20px;
                }
                .expand-icon {
                    font-size: 18px;
                    transition: transform 0.3s ease;
                    color: #1976d2;
                }
                .expanded .expand-icon {
                    transform: rotate(180deg);
                }
                .monitoring-content {
                    background: white;
                    border: 1px solid #e0e0e0;
                    border-top: none;
                    border-radius: 0 0 8px 8px;
                    padding: 20px;
                    margin-top: -5px;
                    animation: slideDown 0.3s ease;
                }
                @keyframes slideDown {
                    from {
                        opacity: 0;
                        transform: translateY(-10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                .monitoring-description {
                    line-height: 1.6;
                    color: #333;
                }
                
                .intro-text {
                    font-size: 16px;
                    margin-bottom: 25px;
                    padding: 15px;
                    background: #f8f9fa;
                    border-radius: 8px;
                    border-left: 4px solid #1976d2;
                }
                
                .monitoring-block {
                    margin-bottom: 30px;
                    padding: 20px;
                    background: white;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                }
                
                .monitoring-block h3 {
                    color: #1976d2;
                    margin-bottom: 15px;
                    font-size: 18px;
                    border-bottom: 2px solid #e3f2fd;
                    padding-bottom: 8px;
                }
                
                .features-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
                    gap: 15px;
                    margin-top: 15px;
                }
                
                .feature-item {
                    display: flex;
                    align-items: flex-start;
                    gap: 12px;
                    padding: 15px;
                    background: #f8f9fa;
                    border-radius: 6px;
                    transition: all 0.3s ease;
                }
                
                .feature-item:hover {
                    background: #e3f2fd;
                    transform: translateY(-2px);
                }
                
                .feature-icon {
                    font-size: 20px;
                    flex-shrink: 0;
                }
                
                .feature-content strong {
                    display: block;
                    margin-bottom: 5px;
                    color: #2c3e50;
                }
                
                .feature-content p {
                    margin: 0;
                    font-size: 14px;
                    color: #666;
                }
                
                .website-link {
                    text-align: center;
                    margin: 15px 0;
                }
                
                .website-link a {
                    color: #1976d2;
                    text-decoration: none;
                    font-weight: bold;
                    font-size: 16px;
                    padding: 10px 20px;
                    border: 2px solid #1976d2;
                    border-radius: 6px;
                    transition: all 0.3s ease;
                    display: inline-block;
                }
                
                .website-link a:hover {
                    background: #1976d2;
                    color: white;
                }
                
                .capabilities-list {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                }
                
                .capability-item {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 12px 15px;
                    background: #f8f9fa;
                    border-radius: 6px;
                }
                
                .capability-badge {
                    font-size: 18px;
                    flex-shrink: 0;
                }
                
                .technical-details {
                    background: #f8f9fa;
                    padding: 20px;
                    border-radius: 8px;
                }
                
                .tech-intro {
                    font-size: 16px;
                    margin-bottom: 20px;
                    color: #2c3e50;
                }
                
                .process-steps {
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                    margin: 20px 0;
                }
                
                .process-step {
                    display: flex;
                    align-items: flex-start;
                    gap: 15px;
                    padding: 15px;
                    background: white;
                    border-radius: 6px;
                    border-left: 4px solid #4caf50;
                }
                
                .step-number {
                    background: #4caf50;
                    color: white;
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: bold;
                    flex-shrink: 0;
                }
                
                .step-content strong {
                    display: block;
                    margin-bottom: 5px;
                    color: #2c3e50;
                }
                
                .step-content p {
                    margin: 0;
                    color: #666;
                    font-size: 14px;
                }
                
                .system-info {
                    background: white;
                    padding: 15px;
                    border-radius: 6px;
                    margin-top: 20px;
                }
                
                .system-info p {
                    margin: 8px 0;
                }
                
                .system-info a {
                    color: #1976d2;
                    text-decoration: none;
                }
                
                .system-info a:hover {
                    text-decoration: underline;
                }
                
                .note-block {
                    background: #fff3e0;
                    border: 1px solid #ffb74d;
                    border-radius: 8px;
                    padding: 20px;
                    margin-top: 20px;
                }
                
                .note-block h3 {
                    color: #f57c00;
                    margin-bottom: 15px;
                }
                
                .excluded-items {
                    margin: 15px 0;
                    padding-left: 20px;
                }
                
                .excluded-items li {
                    margin-bottom: 8px;
                    color: #666;
                }
                
                @media (max-width: 768px) {
                    .features-grid {
                        grid-template-columns: 1fr;
                    }
                    
                    .monitoring-block {
                        padding: 15px;
                    }
                    
                    .process-step {
                        flex-direction: column;
                        text-align: center;
                    }
                    
                    .step-number {
                        align-self: center;
                    }
                    
                    .monitoring-content {
                        padding: 15px;
                    }
                }
                `}
            </style>

            <div 
                className={`monitoring-header ${isExpanded ? 'expanded' : ''}`}
                onClick={toggleSection}
            >
                <h2>О мониторинге</h2>
                <span className="expand-icon">▼</span>
            </div>
            
            {isExpanded && (
                <div className="monitoring-content">
                    <div className="monitoring-description">
                        <p className="intro-text">
                            <strong>Автоматизированный мониторинг организации горячего питания обучающихся</strong> — 
                            это комплексная система, обеспечивающая всесторонний контроль и анализ качества школьного питания.
                        </p>

                        <div className="monitoring-block">
                            <h3>📊 Основные направления мониторинга</h3>
                            <div className="features-grid">
                                <div className="feature-item">
                                    <span className="feature-icon">👀</span>
                                    <div className="feature-content">
                                        <strong>Наблюдение за меню</strong>
                                        <p>Мониторинг меню фактического питания, опубликованных на официальных сайтах образовательных организаций</p>
                                    </div>
                                </div>
                                
                                <div className="feature-item">
                                    <span className="feature-icon">📈</span>
                                    <div className="feature-content">
                                        <strong>Анализ соответствия нормативам</strong>
                                        <p>Выявление отклонений по выходу блюд, калорийности и пищевым веществам от установленных нормативов</p>
                                    </div>
                                </div>
                                
                                <div className="feature-item">
                                    <span className="feature-icon">💰</span>
                                    <div className="feature-content">
                                        <strong>Контроль стоимости</strong>
                                        <p>Мониторинг стоимости комплексов блюд по приемам пищи</p>
                                    </div>
                                </div>
                                
                                <div className="feature-item">
                                    <span className="feature-icon">📋</span>
                                    <div className="feature-content">
                                        <strong>Анализ состава меню</strong>
                                        <p>Изучение состава меню фактического питания</p>
                                    </div>
                                </div>
                                
                                <div className="feature-item">
                                    <span className="feature-icon">⏱️</span>
                                    <div className="feature-content">
                                        <strong>Исполнительская дисциплина</strong>
                                        <p>Контроль своевременности публикации меню на официальных сайтах</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="monitoring-block">
                            <h3>🛠️ Техническая реализация</h3>
                            <div className="implementation-details">
                                <p>
                                    Все перечисленные параметры контролируются с использованием <strong>централизованной базы данных</strong>, 
                                    аналитических отчетов для специалистов ФЦМПО и региональных органов управления образованием, 
                                    а также через публичный интерфейс анализа меню на специализированном интернет-сайте:
                                </p>
                                <div className="website-link">
                                    <a href="https://monitoring.cemon.ru" target="_blank" rel="noopener noreferrer">
                                        https://monitoring.cemon.ru
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="monitoring-block">
                            <h3>🚀 Дополнительные возможности системы</h3>
                            <div className="capabilities-list">
                                <div className="capability-item">
                                    <span className="capability-badge">📊</span>
                                    <span>Построение рейтингов и система общественного контроля</span>
                                </div>
                                <div className="capability-item">
                                    <span className="capability-badge">📝</span>
                                    <span>Визуализация результатов массовых социологических опросов по питанию</span>
                                </div>
                                <div className="capability-item">
                                    <span className="capability-badge">🔗</span>
                                    <span>Интеграция со сторонними информационными ресурсами</span>
                                </div>
                                <div className="capability-item">
                                    <span className="capability-badge">💼</span>
                                    <span>Специализированные рабочие места для региональных управлений образования и экспертов ФЦМПО</span>
                                </div>
                            </div>
                        </div>

                        <div className="monitoring-block">
                            <h3>🎯 Технические особенности работы системы</h3>
                            <div className="technical-details">
                                <p className="tech-intro">
                                    <strong>Задача:</strong> Мониторинг питания обучающихся начальных классов РФ
                                </p>
                                
                                <div className="tech-process">
                                    <h4>Процесс мониторинга меню:</h4>
                                    <div className="process-steps">
                                        <div className="process-step">
                                            <div className="step-number">1</div>
                                            <div className="step-content">
                                                <strong>Регулярное считывание файлов меню</strong>
                                                <p>Автоматическое получение файлов с установленным шаблоном имени «гггг-мм-дд-sm.xlsx»</p>
                                            </div>
                                        </div>
                                        <div className="process-step">
                                            <div className="step-number">2</div>
                                            <div className="step-content">
                                                <strong>Контроль формата</strong>
                                                <p>Проверка считываемых файлов на соответствие установленному формату бланка</p>
                                            </div>
                                        </div>
                                        <div className="process-step">
                                            <div className="step-number">3</div>
                                            <div className="step-content">
                                                <strong>Обработка данных</strong>
                                                <p>Разбор файлов и размещение цифровых документов в информационной базе (вид «Меню фактическое»)</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="system-info">
                                    <p>
                                        <strong>Платформа:</strong> Центральная информационная база ФЦМПО на платформе «1С:Предприятие»
                                    </p>
                                    <p>
                                        <strong>Размещение:</strong> <a href='https://cemon.ru' target="_blank" rel="noopener noreferrer">https://cemon.ru</a>
                                    </p>
                                    <p>
                                        <strong>Режим работы:</strong> Автоматический, один раз в сутки
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="note-block">
                            <h3>💡 Примечание</h3>
                            <div className="note-content">
                                <p>
                                    Иные вопросы, относящиеся к управлению системой школьного питания, выходят за рамки текущей системы мониторинга 
                                    и могут быть реализованы в последующих версиях:
                                </p>
                                <ul className="excluded-items">
                                    <li>Мониторинг формы организации питания и систем ценообразования</li>
                                    <li>Численность питающихся и товарооборот продуктов</li>
                                    <li>Сопоставление с среднесуточными нормативами по продуктовым группам</li>
                                    <li>Контроль питания других возрастных категорий</li>
                                    <li>Обращения граждан и результаты их рассмотрения</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

// Компонент для отображения общей статистики по РФ
// Компонент для отображения общей статистики по РФ
const RussiaStats = ({ data, lastUpdate, autoRefreshEnabled, formatLastUpdate }) => {
    if (!data || data.length === 0) {
        return null;
    }

    // Рассчитываем общие показатели по РФ
    const totalStats = data.reduce((acc, region) => {
        acc.totalChildren += region.Дети;
        acc.totalParents += region.Родители;
        acc.totalSchoolsWithResponses += region.КоличествоШкол;
        acc.totalAllSchools += region.ВсегоШкол;
        acc.totalStudents += region.ВсегоУчащихся;
        return acc;
    }, {
        totalChildren: 0,
        totalParents: 0,
        totalSchoolsWithResponses: 0,
        totalAllSchools: 0,
        totalStudents: 0
    });

    const totalRespondents = totalStats.totalChildren + totalStats.totalParents;
    const percentOfStudents = totalStats.totalStudents > 0 ? (totalStats.totalChildren / totalStats.totalStudents * 100) : 0;
    const percentOfSchools = totalStats.totalAllSchools > 0 ? (totalStats.totalSchoolsWithResponses / totalStats.totalAllSchools * 100) : 0;

    return (
        <div className="russia-stats" style={{ marginBottom: '20px' }}>
            <style>
                {`
                .russia-stats {
                    background: #ffffff;
                    border: 1px solid #e0e0e0;
                    border-radius: 8px;
                    padding: 20px;
                    color: #333;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                }
                .stats-header {
                    border-bottom: 2px solid #1976d2;
                    padding-bottom: 10px;
                    margin-bottom: 15px;
                }
                .stats-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
                    gap: 12px;
                }
                .stat-item {
                    text-align: center;
                    padding: 12px;
                    background: #f8f9fa;
                    border: 1px solid #dee2e6;
                    border-radius: 6px;
                }
                .stat-value {
                    font-size: 20px;
                    font-weight: bold;
                    margin-bottom: 4px;
                    color: #1976d2;
                }
                .stat-label {
                    font-size: 12px;
                    color: #666;
                    margin-bottom: 4px;
                }
                .stat-percent {
                    font-size: 11px;
                    color: #28a745;
                    font-weight: 500;
                }
                .stats-footer {
                    margin-top: 12px;
                    text-align: center;
                    font-size: 11px;
                    color: #666;
                    border-top: 1px solid #e0e0e0;
                    padding-top: 8px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                .update-info {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 2px;
                }
                .auto-refresh-status {
                    color: #28a745;
                    font-weight: 500;
                }
                @media (max-width: 768px) {
                    .stats-grid {
                        grid-template-columns: repeat(2, 1fr);
                        gap: 8px;
                    }
                    .stat-value {
                        font-size: 18px;
                    }
                    .stat-label {
                        font-size: 11px;
                    }
                    .russia-stats {
                        padding: 15px;
                    }
                    .stats-footer {
                        flex-direction: column;
                        gap: 5px;
                        text-align: center;
                    }
                    .update-info {
                        align-items: center;
                    }
                }
                @media (max-width: 480px) {
                    .stats-grid {
                        grid-template-columns: 1fr;
                    }
                }
                `}
            </style>

            <div className="stats-header">
                <h3 style={{ 
                    margin: 0, 
                    fontSize: '18px',
                    fontWeight: '600',
                    color: '#1976d2'
                }}>
                    📊 Общая статистика по Российской Федерации
                </h3>
            </div>

            <div className="stats-grid">
                <div className="stat-item">
                    <div className="stat-value">{totalRespondents.toLocaleString('ru-RU')}</div>
                    <div className="stat-label">Всего респондентов</div>
                </div>
                
                <div className="stat-item">
                    <div className="stat-value">{totalStats.totalChildren.toLocaleString('ru-RU')}</div>
                    <div className="stat-label">Детей опрошено</div>
                    <div className="stat-percent">{percentOfStudents.toFixed(1)}% от учащихся</div>
                </div>
                
                <div className="stat-item">
                    <div className="stat-value">{totalStats.totalParents.toLocaleString('ru-RU')}</div>
                    <div className="stat-label">Родителей опрошено</div>
                </div>
                
                <div className="stat-item">
                    <div className="stat-value">{totalStats.totalSchoolsWithResponses.toLocaleString('ru-RU')}</div>
                    <div className="stat-label">Пищеблоков с ответами</div>
                    <div className="stat-percent">{percentOfSchools.toFixed(1)}% от всех пищеблоков</div>
                </div>
                
                <div className="stat-item">
                    <div className="stat-value">{totalStats.totalAllSchools.toLocaleString('ru-RU')}</div>
                    <div className="stat-label">Всего пищеблоков в мониторинге</div>
                </div>
                
                <div className="stat-item">
                    <div className="stat-value">{Object.keys(FEDERAL_DISTRICTS).length}</div>
                    <div className="stat-label">Федеральных округов</div>
                </div>
            </div>

            <div className="stats-footer">
                <div className="update-info">
                    {lastUpdate && (
                        <div>
                            <strong>Обновлено:</strong> {formatLastUpdate()}
                        </div>
                    )}
                    {autoRefreshEnabled && (
                        <div className="auto-refresh-status">
                            ✅ Автообновление включено
                        </div>
                    )}
                </div>
                <div style={{ fontSize: '10px', color: '#999' }}>
                    Данные обновляются автоматически
                </div>
            </div>
        </div>
    );
};

// Компонент модального окна с детальной информацией по районам
const DistrictModal = ({ isOpen, onClose, regionData, tableData }) => {
    const modalContentRef = useRef(null);
    const modalContainerRef = useRef(null);
    const [expandedDistricts, setExpandedDistricts] = useState({});

    // Блокировка прокрутки основной страницы
    useEffect(() => {
        if (isOpen) {
            // Сохраняем текущую позицию прокрутки
            const scrollY = window.scrollY;
            
            // Блокируем прокрутку body
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';

            // Обработчик для блокировки прокрутки только вне модального окна
            const handleScroll = (e) => {
                // Если событие происходит не внутри модального контента, блокируем его
                if (modalContentRef.current && !modalContentRef.current.contains(e.target)) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
            };

            // Обработчик для touch устройств
            const handleTouchMove = (e) => {
                if (modalContentRef.current && !modalContentRef.current.contains(e.target)) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
            };

            // Блокируем события на уровне document
            document.addEventListener('wheel', handleScroll, { passive: false });
            document.addEventListener('touchmove', handleTouchMove, { passive: false });

            return () => {
                // Восстанавливаем прокрутку
                document.body.style.overflow = '';
                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.width = '';
                
                // Восстанавливаем позицию прокрутки
                window.scrollTo(0, scrollY);
                
                // Убираем обработчики
                document.removeEventListener('wheel', handleScroll);
                document.removeEventListener('touchmove', handleTouchMove);
            };
        }
    }, [isOpen]);

    // Переключение состояния свертывания/развертывания района
    const toggleDistrict = useCallback((districtName) => {
        setExpandedDistricts(prev => ({
            ...prev,
            [districtName]: !prev[districtName]
        }));
    }, []);

    // Развернуть/свернуть все районы
    const toggleAllDistricts = useCallback((expand) => {
        if (!regionData) return;
        
        const districtsData = tableData.reduce((acc, item) => {
            if (item.Регион === regionData.Регион) {
                const districtName = item.Район || 'Без района';
                if (!acc[districtName]) {
                    acc[districtName] = true;
                }
            }
            return acc;
        }, {});

        if (expand) {
            setExpandedDistricts(districtsData);
        } else {
            setExpandedDistricts({});
        }
    }, [regionData, tableData]);

    // Обработчик колесика мыши для контента модального окна
    const handleContentWheel = useCallback((e) => {
        // Разрешаем прокрутку внутри контента модального окна
        e.stopPropagation();
        
        const modalContent = modalContentRef.current;
        if (modalContent) {
            const isAtTop = modalContent.scrollTop === 0;
            const isAtBottom = modalContent.scrollTop + modalContent.clientHeight >= modalContent.scrollHeight - 1;

            // Если достигли границ контента, блокируем дальнейшую прокрутку
            if ((e.deltaY < 0 && isAtTop) || (e.deltaY > 0 && isAtBottom)) {
                e.preventDefault();
            }
        }
    }, []);

    // Функция экспорта данных модального окна в Excel
    const exportModalToExcel = useCallback(() => {
        if (!regionData) return;

        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet(`Детализация по ${regionData.Регион}`);

        // Заголовки
        const headers = [
            'Район',
            'Школа',
            'Код школы',
            'Детей опрошено',
            'Родителей опрошено',
            'Всего респондентов'
        ];

        // Добавляем заголовки
        worksheet.addRow(headers);

        // Стили для заголовков
        const headerRow = worksheet.getRow(1);
        headerRow.font = { bold: true, size: 10 };
        headerRow.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFE0E0E0' }
        };
        headerRow.alignment = { vertical: 'middle', horizontal: 'center' };

        // Группируем данные по районам для экспорта
        const districtsData = tableData.reduce((acc, item) => {
            if (item.Регион === regionData.Регион) {
                const districtName = item.Район || 'Без района';
                if (!acc[districtName]) {
                    acc[districtName] = {
                        district: districtName,
                        schools: [],
                        totalChildren: 0,
                        totalParents: 0,
                        schoolCount: 0,
                        schoolsWithResponses: 0
                    };
                }
                
                const children = parseInt(item.Дети) || 0;
                const parents = parseInt(item.Родители) || 0;
                const hasResponses = children > 0 || parents > 0;
                
                acc[districtName].schools.push({
                    name: item.Наименование,
                    code: item.Код,
                    children: children,
                    parents: parents,
                    hasResponses: hasResponses
                });
                
                acc[districtName].totalChildren += children;
                acc[districtName].totalParents += parents;
                acc[districtName].schoolCount += 1;
                if (hasResponses) {
                    acc[districtName].schoolsWithResponses += 1;
                }
            }
            return acc;
        }, {});

        const districtsArray = Object.values(districtsData).sort((a, b) => b.totalChildren - a.totalChildren);

        // Добавляем данные по районам и школам
        let currentRow = 2;

        districtsArray.forEach((district) => {
            // Заголовок района
            worksheet.addRow([district.district, '', '', '', '', '']);
            const districtRow = worksheet.getRow(currentRow);
            districtRow.font = { bold: true, size: 10 };
            districtRow.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFE3F2FD' }
            };
            currentRow++;

            // Школы в районе
            district.schools.forEach((school) => {
                worksheet.addRow([
                    '', // Пусто для отступа
                    school.name,
                    school.code || '',
                    school.children,
                    school.parents,
                    school.children + school.parents
                ]);
                currentRow++;
            });

            // Итоги по району
            worksheet.addRow([
                '', // Пусто для отступа
                `Итого по району ${district.district}:`,
                '',
                district.totalChildren,
                district.totalParents,
                district.totalChildren + district.totalParents
            ]);
            const totalRow = worksheet.getRow(currentRow);
            totalRow.font = { bold: true };
            totalRow.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFF3E5F5' }
            };
            currentRow++;

        });

        // Общие итоги по региону
        worksheet.addRow([
            'ВСЕГО ПО РЕГИОНУ:',
            '',
            '',
            regionData.Дети,
            regionData.Родители,
            regionData.Дети + regionData.Родители
        ]);
        const grandTotalRow = worksheet.getRow(currentRow);
        grandTotalRow.font = { bold: true, size: 11 };
        grandTotalRow.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFE8F5E8' }
        };

        // Настраиваем ширину колонок
        worksheet.columns = [
            { width: 25 },
            { width: 35 },
            { width: 15 },
            { width: 12 },
            { width: 12 },
            { width: 12 }
        ];

        // Форматируем числовые колонки
        [4, 5, 6].forEach(colIndex => {
            worksheet.getColumn(colIndex).numFmt = '#,##0';
        });

        // Сохраняем файл
        workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `Детализация_${regionData.Регион}.xlsx`);
        });
    }, [regionData, tableData]);

    if (!isOpen || !regionData) return null;

    // Группируем данные по районам
    const districtsData = tableData.reduce((acc, item) => {
        if (item.Регион === regionData.Регион) {
            const districtName = item.Район || 'Без района';
            if (!acc[districtName]) {
                acc[districtName] = {
                    district: districtName,
                    schools: [],
                    totalChildren: 0,
                    totalParents: 0,
                    schoolCount: 0,
                    schoolsWithResponses: 0
                };
            }
            
            const children = parseInt(item.Дети) || 0;
            const parents = parseInt(item.Родители) || 0;
            const hasResponses = children > 0 || parents > 0;
            
            acc[districtName].schools.push({
                name: item.Наименование,
                code: item.Код,
                children: children,
                parents: parents,
                hasResponses: hasResponses
            });
            
            acc[districtName].totalChildren += children;
            acc[districtName].totalParents += parents;
            acc[districtName].schoolCount += 1;
            if (hasResponses) {
                acc[districtName].schoolsWithResponses += 1;
            }
        }
        return acc;
    }, {});

    const districtsArray = Object.values(districtsData).sort((a, b) => b.totalChildren - a.totalChildren);

    return (
        <div 
            ref={modalContainerRef}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                zIndex: 10000,
                padding: '20px 0',
            }} 
            onClick={onClose}
        >

            <div 
                style={{
                    backgroundColor: 'white',
                    padding: '20px',
                    borderRadius: '8px',
                    maxWidth: '95%',
                    width: '900px',
                    maxHeight: '90vh',
                    overflow: 'hidden',
                    position: 'relative',
                    marginTop: '20px'
                }} 
                onClick={(e) => e.stopPropagation()}
            >
                {/* Кнопка закрытия в правом верхнем углу модального окна */}
                <button 
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '15px',
                        right: '15px',
                        background: 'none',
                        border: 'none',
                        borderRadius: '4px',
                        width: '32px',
                        height: '32px',
                        fontSize: '18px',
                        cursor: 'pointer',
                        color: '#666',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.2s ease',
                        zIndex: 1
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#f5f5f5';
                        e.target.style.color = '#333';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'transparent';
                        e.target.style.color = '#666';
                    }}
                >
                    ✕
                </button>

                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '20px',
                    borderBottom: '2px solid #1976d2',
                    paddingBottom: '10px',
                    paddingRight: '40px'
                }}>
                    <p style={{ margin: 0, color: '#1976d2' }}>
                        📊 {regionData.Регион}
                    </p>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <button 
                            onClick={() => toggleAllDistricts(true)}
                            style={{
                                padding: '6px 12px',
                                backgroundColor: '#17a2b8',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '12px',
                                transition: 'background-color 0.2s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#138496';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = '#17a2b8';
                            }}
                        >
                            Развернуть все
                        </button>
                        <button 
                            onClick={() => toggleAllDistricts(false)}
                            style={{
                                padding: '6px 12px',
                                backgroundColor: '#6c757d',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '12px',
                                transition: 'background-color 0.2s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#545b62';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = '#6c757d';
                            }}
                        >
                            Свернуть все
                        </button>
                        <button 
                            onClick={exportModalToExcel}
                            style={{
                                padding: '8px 16px',
                                backgroundColor: '#28a745',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '6px',
                                transition: 'background-color 0.2s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#218838';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = '#28a745';
                            }}
                        >
                            Экспорт
                        </button>
                    </div>
                </div>

                <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '6px' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '10px' }}>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#1976d2' }}>
                                {regionData.Дети.toLocaleString('ru-RU')}
                            </div>
                            <div style={{ fontSize: '12px', color: '#666' }}>Детей опрошено</div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#1976d2' }}>
                                {regionData.Родители.toLocaleString('ru-RU')}
                            </div>
                            <div style={{ fontSize: '12px', color: '#666' }}>Родителей опрошено</div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#1976d2' }}>
                                {regionData.КоличествоШкол.toLocaleString('ru-RU')}
                            </div>
                            <div style={{ fontSize: '12px', color: '#666' }}>Пищеблоков с ответами</div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#1976d2' }}>
                                {regionData.ВсегоШкол.toLocaleString('ru-RU')}
                            </div>
                            <div style={{ fontSize: '12px', color: '#666' }}>Всего пищеблоков</div>
                        </div>
                    </div>
                </div>

                <div 
                    ref={modalContentRef}
                    style={{ 
                        maxHeight: 'calc(90vh - 200px)', 
                        overflow: 'auto',
                        paddingRight: '5px'
                    }}
                    onWheel={handleContentWheel}
                >
                    {districtsArray.map((district, index) => (
                        <div key={district.district} style={{ 
                            marginBottom: '15px',
                            border: '1px solid #e0e0e0',
                            borderRadius: '6px',
                            overflow: 'hidden'
                        }}>
                            <div 
                                style={{
                                    backgroundColor: '#e3f2fd',
                                    padding: '12px',
                                    fontWeight: 'bold',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s ease'
                                }}
                                onClick={() => toggleDistrict(district.district)}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#bbdefb';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = '#e3f2fd';
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <span style={{ 
                                        fontSize: '14px', 
                                        transition: 'transform 0.2s ease',
                                        transform: expandedDistricts[district.district] ? 'rotate(90deg)' : 'rotate(0deg)'
                                    }}>
                                        ▶
                                    </span>
                                    <span>{district.district}</span>
                                </div>
                                <div style={{ display: 'flex', gap: '15px', fontSize: '14px' }}>
                                    <span>👦 {district.totalChildren.toLocaleString('ru-RU')} детей</span>
                                    <span>👨‍👩‍👧‍👦 {district.totalParents.toLocaleString('ru-RU')} родителей</span>
                                    <span>🏫 {district.schoolsWithResponses} пищеблоков с ответами</span>
                                </div>
                            </div>
                            
                            {expandedDistricts[district.district] && (
                                <div style={{ maxHeight: '300px', overflow: 'auto' }}>
                                    <table style={{ 
                                        width: '100%', 
                                        borderCollapse: 'collapse',
                                        fontSize: '12px'
                                    }}>
                                        <thead>
                                            <tr style={{ backgroundColor: '#f5f5f5' }}>
                                                <th style={{ padding: '8px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Школа</th>
                                                <th style={{ padding: '8px', textAlign: 'right', borderBottom: '1px solid #ddd', width: '100px' }}>Дети</th>
                                                <th style={{ padding: '8px', textAlign: 'right', borderBottom: '1px solid #ddd', width: '100px' }}>Родители</th>
                                                <th style={{ padding: '8px', textAlign: 'right', borderBottom: '1px solid #ddd', width: '100px' }}>Всего</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {district.schools.map((school, schoolIndex) => (
                                                <tr 
                                                    key={schoolIndex} 
                                                    style={{ 
                                                        borderBottom: '1px solid #f0f0f0',
                                                        backgroundColor: school.hasResponses ? 'transparent' : '#f9f9f9'
                                                    }}
                                                >
                                                    <td style={{ padding: '8px' }}>
                                                        <div style={{ fontWeight: '500' }}>{school.name}</div>
                                                        {school.code && <div style={{ fontSize: '11px', color: '#666' }}>Код: {school.code}</div>}
                                                        {!school.hasResponses && (
                                                            <div style={{ fontSize: '10px', color: '#999', fontStyle: 'italic' }}>
                                                                Нет ответов
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td style={{ padding: '8px', textAlign: 'right' }}>{school.children.toLocaleString('ru-RU')}</td>
                                                    <td style={{ padding: '8px', textAlign: 'right' }}>{school.parents.toLocaleString('ru-RU')}</td>
                                                    <td style={{ padding: '8px', textAlign: 'right', fontWeight: 'bold' }}>
                                                        {(school.children + school.parents).toLocaleString('ru-RU')}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold' }}>
                                                <td style={{ padding: '8px' }}>Итого по району:</td>
                                                <td style={{ padding: '8px', textAlign: 'right' }}>{district.totalChildren.toLocaleString('ru-RU')}</td>
                                                <td style={{ padding: '8px', textAlign: 'right' }}>{district.totalParents.toLocaleString('ru-RU')}</td>
                                                <td style={{ padding: '8px', textAlign: 'right' }}>
                                                    {(district.totalChildren + district.totalParents).toLocaleString('ru-RU')}
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

// Компонент кастомной таблицы
const CustomSummaryTable = ({ data, onRowClick }) => {
    const [isMobile, setIsMobile] = useState(false);

    // Определяем мобильное устройство
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        
        return () => {
            window.removeEventListener('resize', checkMobile);
        };
    }, []);

    // Функция экспорта в Excel
    const exportToExcel = useCallback(() => {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Сводная таблица по регионам');

        // Заголовки
        const headers = [
            'Федеральный округ',
            'Регион',
            'Детей опрошено',
            '% от учащихся нач.школы в регионе (без ОВЗ)',
            'Родителей опрошено',
            'Пищеблоков с ответами',
            'Всего пищеблоков в базе',
            '% от пищеблоков'
        ];

        // Добавляем заголовки
        worksheet.addRow(headers);

        // Стили для заголовков
        const headerRow = worksheet.getRow(1);
        headerRow.font = { bold: true, size: 10 };
        headerRow.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFE0E0E0' }
        };
        headerRow.alignment = { vertical: 'middle', horizontal: 'center' };

        // Группируем данные по федеральным округам
        const groupedData = data.reduce((acc, item) => {
            const district = item.ФедеральныйОкруг;
            if (!acc[district]) {
                acc[district] = {
                    district,
                    regions: []
                };
            }
            acc[district].regions.push(item);
            return acc;
        }, {});

        // Добавляем данные
        let currentRow = 2;

        Object.values(groupedData).forEach((districtData) => {
            // Заголовок округа
            worksheet.addRow([districtData.district, '', '', '', '', '', '', '']);
            const districtRow = worksheet.getRow(currentRow);
            districtRow.font = { bold: true, size: 10 };
            districtRow.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFE3F2FD' }
            };
            currentRow++;

            // Регионы в округе
            districtData.regions.forEach((region) => {
                const percentStudents = region.ВсегоУчащихся > 0 ? (region.Дети / region.ВсегоУчащихся * 100) : 0;
                const percentSchools = region.ВсегоШкол > 0 ? (region.КоличествоШкол / region.ВсегоШкол * 100) : 0;
                
                worksheet.addRow([
                    '', // Пусто для отступа
                    region.Регион,
                    region.Дети,
                    percentStudents,
                    region.Родители,
                    region.КоличествоШкол,
                    region.ВсегоШкол,
                    percentSchools
                ]);
                currentRow++;
            });

            // Пустая строка для разделения
           
        });

        // Настраиваем ширину колонок
        worksheet.columns = [
            { width: 20 },
            { width: 25 },
            { width: 12 },
            { width: 12 },
            { width: 12 },
            { width: 12 },
            { width: 10 },
            { width: 10 }
        ];

        // Форматируем числовые колонки
        worksheet.getColumn(3).numFmt = '#,##0';
        worksheet.getColumn(5).numFmt = '#,##0';
        worksheet.getColumn(6).numFmt = '#,##0';
        worksheet.getColumn(7).numFmt = '#,##0';
        
        // Форматируем проценты
        worksheet.getColumn(4).numFmt = '0.0"%"';
        worksheet.getColumn(8).numFmt = '0.0"%"';

        // Выравнивание для всех ячеек
        worksheet.eachRow((row) => {
            row.alignment = { vertical: 'middle', horizontal: 'left' };
        });

        // Выравнивание для числовых колонок
        [3, 5, 6, 7].forEach(colIndex => {
            worksheet.getColumn(colIndex).alignment = { horizontal: 'right' };
        });

        // Выравнивание для процентных колонок
        [4, 8].forEach(colIndex => {
            worksheet.getColumn(colIndex).alignment = { horizontal: 'right' };
        });

        // Сохраняем файл
        workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), 'Сводная_таблица_по_регионам.xlsx');
        });
    }, [data]);

    if (!data || data.length === 0) {
        return <div>Нет данных для отображения</div>;
    }

    // Группируем данные по федеральным округам
    const groupedData = data.reduce((acc, item) => {
        const district = item.ФедеральныйОкруг;
        if (!acc[district]) {
            acc[district] = {
                district,
                regions: [],
                totalChildren: 0,
                totalParents: 0,
                totalSchools: 0,
                totalAllSchools: 0
            };
        }
        acc[district].regions.push(item);
        acc[district].totalChildren += item.Дети;
        acc[district].totalParents += item.Родители;
        acc[district].totalSchools += item.КоличествоШкол;
        acc[district].totalAllSchools += item.ВсегоШкол;
        
        return acc;
    }, {});

    // Общие итоги
    const grandTotal = {
        children: data.reduce((sum, item) => sum + item.Дети, 0),
        parents: data.reduce((sum, item) => sum + item.Родители, 0),
        schools: data.reduce((sum, item) => sum + item.КоличествоШкол, 0),
        allSchools: data.reduce((sum, item) => sum + item.ВсегоШкол, 0)
    };

    return (
        <div className="custom-summary-table">
            {/* Кнопка экспорта */}
            <div style={{ marginBottom: '15px', textAlign: 'right' }}>
                <button 
                    onClick={exportToExcel}
                    style={{
                        padding: '8px 16px',
                        backgroundColor: '#28a745',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px'
                    }}
                >
                    📊 Экспорт в Excel
                </button>
            </div>

            <style>
                {`
                .custom-summary-table {
                    font-family: Arial, sans-serif;
                    font-size: 12px;
                    overflow-x: auto;
                }
                .summary-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-bottom: 15px;
                    min-width: ${isMobile ? '700px' : '100%'};
                }
                .summary-table th,
                .summary-table td {
                    border: 1px solid #ddd;
                    padding: 4px 6px;
                    text-align: left;
                    line-height: 1.2;
                }
                .summary-table th {
                    background-color: #f5f5f5;
                    font-weight: bold;
                    position: sticky;
                    top: 0;
                    font-size: 11px;
                }
                .district-header {
                    background-color: #e3f2fd !important;
                    font-weight: bold;
                }
                .district-total {
                    background-color: #f3e5f5 !important;
                    font-weight: bold;
                }
                .grand-total {
                    background-color: #e8f5e8 !important;
                    font-weight: bold;
                    font-size: 12px;
                }
                .region-row:hover {
                    background-color: #f5f5f5;
                    cursor: pointer;
                }
                .region-row:active {
                    background-color: #e0e0e0;
                }
                .percentage-cell {
                    text-align: right;
                    font-weight: 500;
                }
                .number-cell {
                    text-align: right;
                }
                .compact-text {
                    font-size: 11px;
                }
                
                /* Адаптивность для мобильных устройств */
                @media (max-width: 767px) {
                    .custom-summary-table {
                        font-size: 11px;
                    }
                    .summary-table th,
                    .summary-table td {
                        padding: 3px 4px;
                    }
                    .mobile-compact .summary-table th:nth-child(4),
                    .mobile-compact .summary-table td:nth-child(4),
                    .mobile-compact .summary-table th:nth-child(7),
                    .mobile-compact .summary-table td:nth-child(7) {
                        display: none;
                    }
                }
                
                @media (max-width: 480px) {
                    .custom-summary-table {
                        font-size: 10px;
                    }
                    .summary-table th,
                    .summary-table td {
                        padding: 2px 3px;
                    }
                    .mobile-compact .summary-table th:nth-child(4),
                    .mobile-compact .summary-table td:nth-child(4),
                    .mobile-compact .summary-table th:nth-child(5),
                    .mobile-compact .summary-table td:nth-child(5),
                    .mobile-compact .summary-table th:nth-child(7),
                    .mobile-compact .summary-table td:nth-child(7) {
                        display: none;
                    }
                }
                `}
            </style>

            <div className={isMobile ? 'mobile-compact' : ''}>
                <table className="summary-table">
                    <thead>
                        <tr>
                            <th style={{ width: '22%', minWidth: '120px' }}>Федеральный округ / Регион</th>
                            <th style={{ width: '10%', minWidth: '60px' }}>Дети</th>
                            <th style={{ width: '10%', minWidth: '60px' }}>% от уч. нач. школы в регионе</th>
                            <th style={{ width: '10%', minWidth: '60px' }}>Родители</th>
                            <th style={{ width: '10%', minWidth: '60px' }}>Пищеблоки с ответами</th>
                            <th style={{ width: '10%', minWidth: '60px' }}>Всего пищеблоков в базе</th>
                            <th style={{ width: '8%', minWidth: '50px' }}>% от общего кол-ва пищеблоков в базе</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.values(groupedData).map((districtData, districtIndex) => (
                            <React.Fragment key={districtData.district}>
                                {/* Заголовок федерального округа */}
                                <tr className="district-header">
                                    <td colSpan="7" style={{ fontWeight: 'bold', fontSize: isMobile ? '12px' : '13px', padding: '6px' }}>
                                        {districtData.district}
                                    </td>
                                </tr>
                                
                                {/* Регионы в округе */}
                                {districtData.regions.map((region, regionIndex) => (
                                    <tr 
                                        key={region.Регион} 
                                        className="region-row"
                                        onClick={() => onRowClick(region)}
                                    >
                                        <td style={{ paddingLeft: isMobile ? '8px' : '15px' }} className="compact-text">
                                            {region.Регион}
                                        </td>
                                        <td className="number-cell">{region.Дети.toLocaleString('ru-RU')}</td>
                                        <td className="percentage-cell">
                                            {region.ВсегоУчащихся > 0 
                                                ? `${(region.Дети / region.ВсегоУчащихся * 100).toFixed(1)}%`
                                                : '0%'
                                            }
                                        </td>
                                        <td className="number-cell">{region.Родители.toLocaleString('ru-RU')}</td>
                                        <td className="number-cell">{region.КоличествоШкол.toLocaleString('ru-RU')}</td>
                                        <td className="number-cell">{region.ВсегоШкол.toLocaleString('ru-RU')}</td>
                                        <td className="percentage-cell">
                                            {region.ВсегоШкол > 0 
                                                ? `${(region.КоличествоШкол / region.ВсегоШкол * 100).toFixed(1)}%`
                                                : '0%'
                                            }
                                        </td>
                                    </tr>
                                ))}
                                
                                {/* Итоги по федеральному округу */}
                                <tr className="district-total">
                                    <td style={{ fontWeight: 'bold', fontSize: '11px' }}>
                                        {isMobile ? 'Итого:' : `Итого ${districtData.district}:`}
                                    </td>
                                    <td className="number-cell" style={{ fontWeight: 'bold' }}>{districtData.totalChildren.toLocaleString('ru-RU')}</td>
                                    <td className="percentage-cell" style={{ fontWeight: 'bold' }}>-</td>
                                    <td className="number-cell" style={{ fontWeight: 'bold' }}>{districtData.totalParents.toLocaleString('ru-RU')}</td>
                                    <td className="number-cell" style={{ fontWeight: 'bold' }}>{districtData.totalSchools.toLocaleString('ru-RU')}</td>
                                    <td className="number-cell" style={{ fontWeight: 'bold' }}>{districtData.totalAllSchools.toLocaleString('ru-RU')}</td>
                                    <td className="percentage-cell" style={{ fontWeight: 'bold' }}>
                                        {districtData.totalAllSchools > 0 
                                            ? `${(districtData.totalSchools / districtData.totalAllSchools * 100).toFixed(1)}%`
                                            : '0%'
                                        }
                                    </td>
                                </tr>
                                
                                {/* Пустая строка для разделения */}
                                <tr>
                                    <td colSpan="7" style={{ height: '4px', background: 'transparent' }}></td>
                                </tr>
                            </React.Fragment>
                        ))}
                        
                        {/* Общие итоги */}
                        <tr className="grand-total">
                            <td style={{ fontSize: '12px' }}>ВСЕГО:</td>
                            <td className="number-cell">{grandTotal.children.toLocaleString('ru-RU')}</td>
                            <td className="percentage-cell">-</td>
                            <td className="number-cell">{grandTotal.parents.toLocaleString('ru-RU')}</td>
                            <td className="number-cell">{grandTotal.schools.toLocaleString('ru-RU')}</td>
                            <td className="number-cell">{grandTotal.allSchools.toLocaleString('ru-RU')}</td>
                            <td className="percentage-cell">
                                {grandTotal.allSchools > 0 
                                    ? `${(grandTotal.schools / grandTotal.allSchools * 100).toFixed(1)}%`
                                    : '0%'
                                }
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            
        </div>
    );
};

export default function Home() {
    // Руссификация
    locale(sessionStorage.getItem('locale') || 'ru');
    loadMessages(ruMessages);

    // Состояния
    const [tableData, setTableData] = useState([]);
    const [regionalData, setRegionalData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [lastUpdate, setLastUpdate] = useState(null);
    const [autoRefreshEnabled, setAutoRefreshEnabled] = useState(true);

    // Состояние для модального окна
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedRegion, setSelectedRegion] = useState(null);

    // Ref для хранения данных и управления обновлениями
    const dataMapRef = useRef(new Map());
    const refreshIntervalRef = useRef();
    const chartDataRef = useRef([]);

    // Функция для вычисления агрегированных данных
    const calculateAggregatedData = useCallback((data) => {
        console.log('Вычисление агрегированных данных для', data.length, 'записей');
        
        // Создаем карту регионов с данными из STUDENTS_DATA
        const regionsMap = {};
        
        // Инициализируем все регионы из STUDENTS_DATA
        Object.keys(STUDENTS_DATA).forEach(regionName => {
            regionsMap[regionName] = {
                ФедеральныйОкруг: getFederalDistrict(regionName),
                Регион: regionName,
                Дети: 0,
                Родители: 0,
                КоличествоШкол: 0,
                ВсегоУчащихся: STUDENTS_DATA[regionName] || 0,
                ВсегоШкол: 0
            };
        });

        // Сначала считаем общее количество школ по регионам
        const schoolsByRegion = {};
        data.forEach(item => {
            if (item.Регион && String(item.Регион).trim() !== '') {
                if (!schoolsByRegion[item.Регион]) {
                    schoolsByRegion[item.Регион] = new Set();
                }
                // Добавляем уникальный идентификатор школы (Код или Наименование)
                const schoolId = item.Код || item.Наименование;
                if (schoolId && String(schoolId).trim() !== '') {
                    schoolsByRegion[item.Регион].add(String(schoolId));
                }
            }
        });

        // Заполняем общее количество школ в регионах
        Object.keys(schoolsByRegion).forEach(regionName => {
            if (regionsMap[regionName]) {
                regionsMap[regionName].ВсегоШкол = schoolsByRegion[regionName].size;
            }
        });

        // Теперь считаем школы с ответами и опрошенных
        data.forEach(item => {
            if (!item.Регион || String(item.Регион).trim() === '') return;

            const children = parseInt(item.Дети) || 0;
            const parents = parseInt(item.Родители) || 0;
            
            // Проверяем, есть ли ответы от родителей ИЛИ детей
            const hasResponses = children > 0 || parents > 0;

            // Обновляем данные по регионам
            if (regionsMap[item.Регион]) {
                if (hasResponses) {
                    regionsMap[item.Регион].Дети += children;
                    regionsMap[item.Регион].Родители += parents;
                    regionsMap[item.Регион].КоличествоШкол += 1;
                }
            }
        });

        // Данные по округам для графиков
        const districtsMap = {};
        Object.keys(FEDERAL_DISTRICTS).forEach(district => {
            districtsMap[district] = { 
                ФедеральныйОкруг: district, 
                Дети: 0, 
                Родители: 0, 
                КоличествоШкол: 0 
            };
        });

        // Заполняем данные по округам
        Object.values(regionsMap).forEach(region => {
            const district = region.ФедеральныйОкруг;
            if (districtsMap[district]) {
                districtsMap[district].Дети += region.Дети;
                districtsMap[district].Родители += region.Родители;
                districtsMap[district].КоличествоШкол += region.КоличествоШкол;
            }
        });

        // Для графиков оставляем только округа с ответами
        chartDataRef.current = Object.values(districtsMap).filter(district => district.КоличествоШкол > 0);
        
        // Для таблицы берем все регионы, отсортированные по ФО и количеству детей
        const regionalDataForTable = Object.values(regionsMap)
            .filter(region => region.ВсегоУчащихся > 0)
            .sort((a, b) => {
                if (a.ФедеральныйОкруг !== b.ФедеральныйОкруг) {
                    return a.ФедеральныйОкруг.localeCompare(b.ФедеральныйОкруг);
                }
                return b.Дети - a.Дети;
            });

        console.log('Региональные данные для таблицы:', regionalDataForTable.length, 'регионов');
        setRegionalData(regionalDataForTable);
    }, []);

    // Загрузка данных
    const loadTableData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const timestamp = Date.now();
            //const url = `https://apistatopros2025.paragraf.spb.ru/data/all.json?t=${timestamp}`;
            const url = `https://apiopros2026.cemon.ru/api/foodblocks`;
          
            
            console.log('Загрузка данных из:', url);
            const response = await fetch(url);
            if (!response.ok) throw new Error(`Ошибка HTTP: ${response.status}`);
            
            const data = await response.json();
            console.log('Данные успешно загружены:', data.length, 'записей');
            
            // Сохраняем данные в Map для быстрого доступа
            dataMapRef.current.clear();
            data.forEach(item => {
                dataMapRef.current.set(item.Код, item);
            });
            
            setTableData(data);
            calculateAggregatedData(data);
            setLastUpdate(new Date());
        } catch (error) {
            console.error('Ошибка загрузки:', error);
            setError('Не удалось загрузить данные: ' + error.message);
        } finally {
            setLoading(false);
        }
    }, [calculateAggregatedData]);

    // Эффективное обновление только числовых значений
    const updateNumericValues = useCallback(async () => {
        if (tableData.length === 0) return;

        try {
            const timestamp = Date.now();
            const url = `https://apistatopros2025.paragraf.spb.ru/data/all.json?t=${timestamp}`;
            
            const response = await fetch(url);
            if (!response.ok) return;
            
            const newData = await response.json();
            let hasChanges = false;

            // Создаем Map новых данных для быстрого поиска
            const newDataMap = new Map();
            newData.forEach(item => newDataMap.set(item.Код, item));

            // Обновляем данные только если есть изменения
            const updatedData = tableData.map(oldItem => {
                const newItem = newDataMap.get(oldItem.Код);
                if (!newItem) return oldItem;

                const oldChildren = parseInt(oldItem.Дети) || 0;
                const oldParents = parseInt(oldItem.Родители) || 0;
                const newChildren = parseInt(newItem.Дети) || 0;
                const newParents = parseInt(newItem.Родители) || 0;

                if (oldChildren !== newChildren || oldParents !== newParents) {
                    hasChanges = true;
                    return {
                        ...oldItem,
                        Дети: newChildren,
                        Родители: newParents
                    };
                }
                return oldItem;
            });

            if (hasChanges) {
                console.log('Обнаружены изменения в данных, обновляем все компоненты...');
                setTableData(updatedData);
                calculateAggregatedData(updatedData);
                setLastUpdate(new Date());
                console.log('Данные обновлены:', new Date().toLocaleTimeString());
            } else {
                console.log('Изменений в данных нет');
            }
        } catch (error) {
            console.error('Ошибка обновления:', error);
        }
    }, [tableData, calculateAggregatedData]);

    // Управление автообновлением
    const startAutoRefresh = useCallback(() => {
        if (refreshIntervalRef.current) {
            console.log('Автообновление уже запущено');
            return;
        }

        console.log('Запуск автообновления (каждые 2 минуты)');
        refreshIntervalRef.current = setInterval(() => {
            console.log('Автообновление: проверка изменений...');
            updateNumericValues();
        }, 120000); // 2 минуты = 120000 миллисекунд
        
        setAutoRefreshEnabled(true);
    }, [updateNumericValues]);

    const stopAutoRefresh = useCallback(() => {
        if (refreshIntervalRef.current) {
            console.log('Остановка автообновления');
            clearInterval(refreshIntervalRef.current);
            refreshIntervalRef.current = null;
        }
        setAutoRefreshEnabled(false);
    }, []);

    // Инициализация - загрузка данных и запуск автообновления
    useEffect(() => {
        console.log('Инициализация компонента: загрузка данных');
        loadTableData();
        
        // Запускаем автообновление через 5 секунд после загрузки данных
        const autoRefreshTimer = setTimeout(() => {
            console.log('Запуск автообновления после начальной загрузки');
            startAutoRefresh();
        }, 5000);
        
        return () => {
            console.log('Очистка компонента');
            clearTimeout(autoRefreshTimer);
            stopAutoRefresh();
        };
    }, []); // Пустой массив зависимостей - выполняется только при монтировании

    // Обработчики
    const onExporting = (e) => {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Выгрузка');
        exportDataGrid({
            component: e.component,
            worksheet,
            autoFilterEnabled: true,
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), 'Экспорт.xlsx');
            });
        });
    };

    const perehod = useCallback(({ value, columnIndex }) => {
        if (columnIndex === 0) copy(value);
    }, []);

    const handleRefresh = useCallback(() => {
        console.log('Ручное обновление данных');
        loadTableData();
    }, [loadTableData]);

    const toggleAutoRefresh = useCallback(() => {
        if (autoRefreshEnabled) {
            stopAutoRefresh();
        } else {
            startAutoRefresh();
        }
    }, [autoRefreshEnabled, startAutoRefresh, stopAutoRefresh]);

    const formatLastUpdate = useCallback(() => {
        return lastUpdate ? lastUpdate.toLocaleTimeString('ru-RU') : '';
    }, [lastUpdate]);

    const formatFullLastUpdate = useCallback(() => {
        return lastUpdate ? lastUpdate.toLocaleString('ru-RU') : '';
    }, [lastUpdate]);

    // Обработчик клика по строке
    const handleRowClick = useCallback((regionData) => {
        setSelectedRegion(regionData);
        setModalOpen(true);
    }, []);

    // Закрытие модального окна
    const handleCloseModal = useCallback(() => {
        setModalOpen(false);
        setSelectedRegion(null);
    }, []);

    return (
        <React.Fragment>
            <MonitoringSection />
             

            <h2 className={'content-block'}>Справочник пищеблоков</h2>

            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>
                    {loading && tableData.length === 0 ? (
                        <div>Загрузка данных...</div>
                    ) : error ? (
                        <div style={{ color: 'red', padding: '20px', textAlign: 'center' }}>
                            {error}
                            <button 
                                onClick={handleRefresh}
                                style={{
                                    marginLeft: '10px',
                                    padding: '5px 10px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer'
                                }}
                            >
                                Повторить
                            </button>
                        </div>
                    ) : (
                        <>
                            <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div>
                                    <strong>Всего записей:</strong> {tableData.length}
                                    {lastUpdate && (
                                        <span style={{ marginLeft: '15px', fontSize: '12px', color: '#666' }}>
                                            Последнее обновление: {formatLastUpdate()}
                                        </span>
                                    )}
                                </div>
                                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                    <button 
                                        onClick={handleRefresh}
                                        style={{
                                            padding: '5px 10px',
                                            backgroundColor: '#007bff',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            fontSize: '12px'
                                        }}
                                    >
                                        🔄 Обновить
                                    </button>
                                    <button 
                                        onClick={toggleAutoRefresh}
                                        style={{
                                            padding: '5px 10px',
                                            backgroundColor: autoRefreshEnabled ? '#dc3545' : '#28a745',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            fontSize: '12px'
                                        }}
                                    >
                                        {autoRefreshEnabled ? '❌ Остановить автообновление' : '✅ Включить автообновление'}
                                    </button>
                                </div>
                            </div>
                            <DataGrid
                                dataSource={tableData}
                                showBorders={true}
                                allowColumnResizing={true}
                                columnAutoWidth={true}
                                onExporting={onExporting}
                                wordWrapEnabled={true}
                                onCellDblClick={perehod}
                                cacheEnabled={false}
                                keyExpr="Код"
                            >
                                <FilterRow visible={true}/>
                                <SearchPanel visible={true}/>
                                <HeaderFilter visible={true}/>
                                <Paging pageSize={10}/>
                                <Export enabled={true}/>
                                <LoadPanel enabled={true} />
                                <Column dataField="Код" allowSearch={false} />
                                <Column dataField="Наименование" allowSearch={true} />
                                <Column dataField="Регион" />
                                <Column dataField="Район" />
                                <Column dataField="Родители" caption="Родителей опрошено" dataType="number" />
                                <Column dataField="Дети" caption="Детей опрошено" dataType="number" />
                            </DataGrid>
                        </>
                    )}
                </div>
            </div>

            <h2 className={'content-block'}>Статистика опроса 2026 по федеральным округам</h2>
            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>
                    {loading && chartDataRef.current.length === 0 ? (
                        <div>Загрузка данных для графика...</div>
                    ) : (
                        <Chart 
                            dataSource={chartDataRef.current}
                        >
                            <Title
                                text="Количество респондентов по федеральным округам"
                                verticalAlignment="top"
                                font={{ color: '#115FA3', size: 16, weight: 'bold' }}
                            />
                            <Series 
                                valueField="Дети" 
                                argumentField="ФедеральныйОкруг" 
                                type="bar" 
                                color="#115FA3" 
                                name="Дети"
                            >
                                <Label
                                    visible={true}
                                    backgroundColor="#FFFFFF"
                                    font={{ color: '#115FA3', weight: 'bold' }}
                                    customizeText={(pointInfo) => {
                                        return pointInfo.valueText.toLocaleString('ru-RU');
                                    }}
                                />
                            </Series>
                            <Series 
                                valueField="Родители" 
                                argumentField="ФедеральныйОкруг" 
                                type="bar" 
                                color="#0F6CFF" 
                                name="Родители"
                            >
                                <Label
                                    visible={true}
                                    backgroundColor="#FFFFFF"
                                    font={{ color: '#0F6CFF', weight: 'bold' }}
                                    customizeText={(pointInfo) => {
                                        return pointInfo.valueText.toLocaleString('ru-RU');
                                    }}
                                />
                            </Series>
                            <ArgumentAxis />
                            <ValueAxis>
                                <Label customizeText={(value) => value.value.toLocaleString('ru-RU')} />
                            </ValueAxis>
                            <Legend 
                                visible={true} 
                                verticalAlignment="bottom"
                                horizontalAlignment="center"
                            />
                        </Chart>
                    )}
                </div>
            </div>

            <h2 className={'content-block'}>Сводная таблица по регионам</h2>
<div className={'content-block'}>
    <div className={'dx-card responsive-paddings'}>
        {loading ? (
            <div>Загрузка данных...</div>
        ) : regionalData.length === 0 ? (
            <div>Нет данных для отображения</div>
        ) : (
            <>
                <RussiaStats 
                    data={regionalData} 
                    lastUpdate={lastUpdate}
                    autoRefreshEnabled={autoRefreshEnabled}
                    formatLastUpdate={formatLastUpdate}
                />
                <CustomSummaryTable 
                    data={regionalData} 
                    onRowClick={handleRowClick}
                />
            </>
        )}
    </div>
</div>

            {/* Модальное окно */}
            <DistrictModal 
                isOpen={modalOpen}
                onClose={handleCloseModal}
                regionData={selectedRegion}
                tableData={tableData}
            />
        </React.Fragment>
    );
}